import { useCallback, useEffect, useState } from 'react';
import taskService from '../../../services/TaskService';
import { mapTaskToRow } from '../helper/helper';

export default function useFetchCreatedByMe() {
  const [createdByMeLoading, setCreatedByMeLoading] = useState(false);
  const [createdByMeRows, setCreatedByMeRows] = useState([]);

  const refreshCreatedByMe = useCallback(async ({ showLoading = false } = {}) => {
    try {
      if (showLoading) setCreatedByMeLoading(true);
      const response = await taskService.getCreatedByMe();
      const tasks = response?.data?.data || [];
      setCreatedByMeRows(tasks.map(mapTaskToRow));
    } catch (error) {
      // eslint-disable-next-line no-console, no-undef
      console.error('Error fetching created tasks:', error);
    } finally {
      if (showLoading) setCreatedByMeLoading(false);
    }
  }, []);

  useEffect(() => {
    refreshCreatedByMe({ showLoading: true });
  }, [refreshCreatedByMe]);

  return { createdByMeRows, setCreatedByMeRows, createdByMeLoading, refreshCreatedByMe };
}
